import { render } from "./task-history-modal.vue?vue&type=template&id=50d8ff5e"
import script from "./task-history-modal.vue?vue&type=script&lang=js"
export * from "./task-history-modal.vue?vue&type=script&lang=js"

import "./task-history-modal.vue?vue&type=style&index=0&id=50d8ff5e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__